
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 405 197","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#115AA5","d":"M0 0h405v197H0z"}}),_c('g',{attrs:{"opacity":".3"}},[_c('path',{attrs:{"d":"M-189.656 21.85c78.35 0 142.074-63.808 142.074-142.262h79.168c0 122.154-99.25 221.535-221.242 221.535V21.851z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M143.298 178.443C103.24 138.332 78.414 82.942 78.414 21.852h79.168c0 39.134 15.865 74.654 41.507 100.383","fill":"#AFC5DA"}}),_c('path',{attrs:{"d":"M299.683-120.464c-78.35 0-142.074 63.808-142.074 142.263H78.441c0-122.155 99.25-221.535 221.242-221.535v79.272z","fill":"#AFC5DA"}}),_c('path',{attrs:{"d":"M173.66 101.149c-78.35 0-142.075 63.809-142.075 142.263h-79.167c0-122.154 99.25-221.535 221.242-221.535v79.272z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M315.735 243.412c0-78.454-63.724-142.263-142.075-142.263V21.877c121.993 0 221.242 99.381 221.242 221.535h-79.167z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M299.684 164.14c78.35 0 142.074-63.809 142.074-142.263h79.167c0 122.154-99.249 221.535-221.241 221.535V164.14z","fill":"#AFC5DA"}}),_c('path',{attrs:{"d":"M199.119 122.26c25.747 25.861 61.325 41.879 100.566 41.879v79.272c-61.009 0-116.3-24.858-156.384-64.969","fill":"#AFC5DA"}})])])
          )
        }
      }
    